import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, takeEvery, call, put, all, select } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestPleitoPostoAnexo({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'pleito/pleitoanexo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deletePleitoPostoAnexo({ payload }) {
  try {
    const { idpleitopostoanexo, params } = payload;

    console.log(idpleitopostoanexo)

    yield call(api.delete, `pleito/pleitoanexodelete/${idpleitopostoanexo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}


export function* store({ payload }) {
  try {
    const { pleito, params } = payload;

    yield call(api.post, 'pleito/posto', pleito);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/cadacom_pleitoposto');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idpleito } = payload;

    const { data } = yield call(api.get, `pleito/${idpleito}`);

    // data.param5usuariooperador = JSON.stringify(data.param5usuariooperador);
    // data.param7usuariooperador = JSON.stringify(data.param7usuariooperador);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}


export function* update({ payload }) {
  try {
    const { pleito, params } = payload;

    yield call(api.put, 'pleito/posto', pleito);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/cadacom_pleitoposto');
  } catch (erros) {
    console.log(erros)
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {

    const { params } = payload

    const response = yield call(api.get, 'pleito/pleitoanexo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });


    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    console.log(erros)
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@pleitopostoanexo/PLEITOPOSTOANEXO_IN_REQUEST', requestPleitoPostoAnexo),
  takeLatest('@pleitopostoanexo/DELETE_PLEITOPOSTOANEXO', deletePleitoPostoAnexo),
  takeLatest('@pleitopostoanexo/SUCCESS_REMOVE', requestPleitoPostoAnexo),
  takeLatest('@pleitopostoanexo/STORE_PLEITOPOSTOANEXO', store),
  takeLatest('@pleitopostoanexo/FIND_PLEITOPOSTOANEXO', find),
  takeLatest('@pleitopostoanexo/UPDATE_PLEITOPOSTOANEXO', update),
  takeLatest('@pleitopostoanexo/RECORD_FILTERING', applyedFilters),
]);
